import { mapActions, mapGetters, mapMutations } from 'vuex'
import { debounce } from 'lodash'

import validation from '@/mixins/validation'
import mixins from '@/mixins'

export default {
	name	: 'ab-filter-results',
	mixin	: [mixins, validation],
	data () {
		return {
			filter: {
				categories	: '',
				keywords	: ''
			}
		}
	},
	computed: {
		...mapGetters({
			filterCategories	: 'tests/filterCategories',
			filterKeywords		: 'tests/filterKeywords',
			setting				: 'courses/setting',
			categories			: 'educationCategories/list',
			categoriesLoading	: 'educationCategories/isLoading'
		})
	},
	created () {
		if (this.categories.length <= 0) {
			this.fetchCategories().then(() => {
				this.setFilters()
			})
		}
		
		this.setFilters()
	},
	methods	: {
		...mapActions({
			fetchList		: 'tests/GET_LIST',
			fetchCategories	: 'educationCategories/GET_LIST'
		}),
		...mapMutations({
			changeFilter: 'tests/CHANGE_LIST_FILTER'
		}),
		setFilters () {
			this.filter.categories = this.filterCategories
			this.filter.keywords = this.filterKeywords
		},
		sendRequest: debounce(function () {
			this.fetchList()
		}, 500),
		changeFilterLocal (val, type) {
			this.changeFilter({
				type	: type,
				value	: val
			})
			
			this.sendRequest()
		}
	}
}
